/* Metalika Studio - collection "Load more". Added 30 Aug 2026.
 *
 * Replaces numbered pagination with a single Load more button, without
 * touching the theme's pagination markup: the original pager is kept in the
 * DOM (hidden, aria-hidden) so that if this script fails for any reason the
 * shopper can still reach page 2. Progressive enhancement, no dependencies.
 *
 * Why code and not the section setting: the theme's own
 * "pagination: click_to_load" option lives in a 58 KB template JSON that is
 * only editable through the theme editor, and the editor renders inside a
 * cross-origin iframe that could not be driven reliably. This produces the
 * same shopper-facing behaviour and is removed by deleting one script tag.
 */
(function () {
  'use strict';
  var doc = document;
  if (!doc.body || doc.body.className.indexOf('theme-template-collection') === -1) {
    if (!doc.querySelector('.x-section-collection-banner')) return;
  }

  function grid() {
    return doc.getElementById('items-grid') || doc.getElementById('product-grid') ||
      (function () { var it = doc.querySelector('.grid-item'); return it ? it.parentElement : null; })();
  }

  /* Read the next page URL out of whatever pager the theme rendered. Rather
   * than trusting a "Next" label (which is themed and translated), compare the
   * page numbers in the links against the page we are on. */
  function nextFrom(root, currentPage) {
    var links = root.querySelectorAll('.pagination a[href*="page="], nav[role="navigation"] a[href*="page="]');
    var best = null, bestN = Infinity;
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var m = href.match(/[?&]page=(\d+)/);
      if (!m) continue;
      var n = parseInt(m[1], 10);
      if (n > currentPage && n < bestN) { bestN = n; best = links[i].href; }
    }
    return best ? { url: best, page: bestN } : null;
  }

  function pageOf(url) {
    var m = String(url).match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function styles() {
    if (doc.getElementById('mtk-more-css')) return;
    var s = doc.createElement('style');
    s.id = 'mtk-more-css';
    s.textContent =
      '.mtk-more-wrap{display:flex;flex-direction:column;align-items:center;gap:14px;' +
      'padding:56px 20px 8px;text-align:center}' +
      '.mtk-more-count{font-family:Jost,var(--font-body-family,sans-serif);font-size:11px;' +
      'letter-spacing:.16em;text-transform:uppercase;color:#7C746A;margin:0}' +
      '.mtk-more{font-family:Jost,var(--font-body-family,sans-serif);font-size:12px;' +
      'letter-spacing:.18em;text-transform:uppercase;color:#1A1714;background:transparent;' +
      'border:1px solid #463F37;border-radius:0;padding:15px 46px;cursor:pointer;' +
      'transition:background-color .25s ease,color .25s ease;min-height:48px}' +
      '.mtk-more:hover{background:#1A1714;color:#FCFBF9}' +
      '.mtk-more:focus-visible{outline:2px solid #9B7A45;outline-offset:3px}' +
      '.mtk-more[disabled]{opacity:.55;cursor:default}' +
      '.mtk-more[disabled]:hover{background:transparent;color:#1A1714}' +
      '.mtk-more-hidden{display:none !important}';
    doc.head.appendChild(s);
  }

  function totalPieces() {
    try {
      var meta = (window.MTK_COL && window.MTK_COL.meta) || [];
      for (var i = 0; i < meta.length; i++) {
        if (/piece/i.test(meta[i][0])) {
          var n = parseInt(String(meta[i][1]).replace(/[^\d]/g, ''), 10);
          if (n) return n;
        }
      }
    } catch (e) { }
    return 0;
  }

  var obs = null;

  function init() {
    if (obs) { obs.disconnect(); obs = null; }
    var old = doc.querySelector('.mtk-more-wrap');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var g = grid();
    if (!g) return;
    var pager = doc.querySelector('.pagination');
    if (!pager) return;                       /* single page - nothing to do */
    var next = nextFrom(doc, pageOf(location.href));
    if (!next) return;

    styles();
    pager.classList.add('mtk-more-hidden');
    pager.setAttribute('aria-hidden', 'true');

    var wrap = doc.createElement('div');
    wrap.className = 'mtk-more-wrap';

    var count = doc.createElement('p');
    count.className = 'mtk-more-count';
    count.setAttribute('role', 'status');
    count.setAttribute('aria-live', 'polite');

    var btn = doc.createElement('button');
    btn.type = 'button';
    btn.className = 'mtk-more';
    btn.textContent = 'Load more';

    wrap.appendChild(count);
    wrap.appendChild(btn);
    pager.parentNode.insertBefore(wrap, pager);

    var total = totalPieces();
    function shown() { return g.querySelectorAll('.card-product').length; }
    function tick() {
      count.textContent = total
        ? 'Showing ' + shown() + ' of ' + total
        : 'Showing ' + shown();
    }
    tick();

    var busy = false;
    btn.addEventListener('click', function () {
      if (busy || !next) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Loading';

      fetch(next.url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var src = d.getElementById('items-grid') || d.getElementById('product-grid');
          var items = src ? src.querySelectorAll('.grid-item') : [];
          var frag = doc.createDocumentFragment();
          var added = 0;
          for (var i = 0; i < items.length; i++) {
            /* products only - never duplicate the promotion tile */
            if (!items[i].querySelector('.card-product')) continue;
            frag.appendChild(doc.importNode(items[i], true));
            added++;
          }
          /* Keep the promotion tile last: it was demoted out of slot 1 and
           * must not end up buried mid-grid by the append. */
          var promo = g.querySelector('[data-mtk-promo]');
          if (promo) g.insertBefore(frag, promo);
          else g.appendChild(frag);

          if (window.Alpine && window.Alpine.initTree) {
            try { window.Alpine.initTree(g); } catch (e) { }
          }

          next = nextFrom(d, next.page);
          tick();

          if (next) {
            btn.disabled = false;
            btn.textContent = 'Load more';
          } else {
            wrap.removeChild(btn);
          }
          busy = false;
          if (!added && next) { btn.click(); }
        })
        .catch(function () {
          /* Fall back to the theme's own pager rather than dead-ending. */
          busy = false;
          btn.disabled = false;
          btn.textContent = 'Load more';
          pager.classList.remove('mtk-more-hidden');
          pager.removeAttribute('aria-hidden');
        });
    });

    /* Filtering re-renders the grid and its pager; rebuild against the new one. */
    if (window.MutationObserver) {
      var t = null;
      obs = new MutationObserver(function () {
        window.clearTimeout(t);
        t = window.setTimeout(function () {
          if (!doc.contains(wrap) || !doc.contains(pager)) init();
          else tick();
        }, 120);
      });
      obs.observe(g.parentNode || g, { childList: true, subtree: true });
    }
  }

  function boot() { try { init(); } catch (e) { } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
